import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";
import state from './state';
import mutations from './mutations';
import * as actions from './actions';
import * as getters from './getters';
import openBidById from './modules/openBidById';
import getLogin from './modules/getLogin';
import menuStatus from './modules/getMenu';
import getBidStatus from './modules/getClock';
import getBidIdStatus from './modules/getOpenBid';
import getWebsocket from './modules/getWebsocket';
import openSocket from './modules/openSocket';
import bidderDecrypt from './modules/bidderDecrypt';
import report from './modules/report';
import getReadBid from './modules/getReadBid';
import getBidSection from './modules/getBidSection';
import updateDecrypt from './modules/updateDecrypt';
import getAlternateBidder from './modules/getAlternateBidder';

// 开标项目
import openbidProject from './modules/openbidProject';
// 历史项目
import historyProject from './modules/historyProject';
// 开标结束
import bidOpeningEnd from './modules/bidOpeningEnd';

// 辅助工具栏-流标
import toolbar from './modules/toolbar';
// 辅助工具栏-开标结果
import openResult from './modules/openResult';

Vue.use(Vuex);

// const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    getLogin,
    updateDecrypt,
    openBidById,
    menuStatus,
    getBidStatus,
    getBidIdStatus,
    getWebsocket,
    openSocket,
    bidderDecrypt,
    report,
    getReadBid,
    getBidSection,
    openbidProject,
    historyProject,
    bidOpeningEnd,
    toolbar,
    openResult,
    getAlternateBidder
  },
  plugins:[
    createPersistedState({
      key:'open-web',
      storage:window.sessionStorage,
      //需要存储的modules
      paths:['openbidProject','report','openResult','locale','getAlternateBidder']
    })
  ]
  // strict: debug,
  // plugins: debug ? [createLogger()] : []
});
